"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoJudgeManager = void 0;
const inversify_1 = require("inversify");
const JudgeManager_1 = require("./JudgeManager");
const GameState_1 = require("./GameState");
let AutoJudgeManager = class AutoJudgeManager extends JudgeManager_1.AbsctractJudgeManager {
    constructor(state) {
        super();
        let nextJudgeIndex = 0;
        let nextSoundIndex = 0;
        const list = state.map.notes;
        const animloop = () => {
            if (state.ended)
                return;
            requestAnimationFrame(animloop);
            if (state.paused)
                return;
            const time = state.GetMusicTime();
            let i = nextJudgeIndex;
            while (i < list.length && list[i].time <= time) {
                const note = list[i];
                note.judge = "perfect";
                if (note.type === "slidestart") {
                    note.parent.pointerId = 1;
                    note.parent.nextJudgeIndex = 1;
                }
                else if (note.type === "slideamong") {
                    note.parent.nextJudgeIndex++;
                }
                else if (note.type === "slideend" || note.type === "flickend") {
                    note.parent.pointerId = 0;
                }
                state.on.judge.emit(note);
                i++;
            }
            nextJudgeIndex = i;
            i = nextSoundIndex;
            while (i < list.length && list[i].time < time + 0.04) {
                const note = list[i];
                const type = note.type === "flick" || note.type === "flickend" ? "flick" : "perfect";
                state.on.soundEffect.emit(type, note.time - time);
                i++;
            }
            nextSoundIndex = i;
        };
        requestAnimationFrame(animloop);
    }
};
AutoJudgeManager = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [GameState_1.GameState])
], AutoJudgeManager);
exports.AutoJudgeManager = AutoJudgeManager;
//# sourceMappingURL=JudgeManager.Auto.js.map